import { Component, inject, signal } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { AccountService } from '@services/account.service';
import { LoginModalComponent } from '../login-modal/login-modal.component';
import { Location } from '@angular/common';
import { Notifier } from '@services/notifier.service';
import { Overlay } from '@angular/cdk/overlay';

@Component({
    selector: 'app-reset-change-password-modal',

    imports: [TranslocoModule, FormsModule, ReactiveFormsModule],
    templateUrl: './reset-change-password-modal.component.html',
    styleUrl: './reset-change-password-modal.component.scss',
})
export class ResetChangePasswordModalComponent {
    formGroup = new FormGroup({
        password: new FormControl('', [Validators.required, this.passwordValidator()]),
    });

    dialogRef = inject(MatDialogRef<ResetChangePasswordModalComponent>);
    router = inject(Router);
    dialog = inject(MatDialog);
    private overlay = inject(Overlay);
    dialogData: { token: string } = inject(MAT_DIALOG_DATA);
    accountService = inject(AccountService);
    notifier = inject(Notifier);
    location = inject(Location);
    errorMessage = signal('');
    passwordType = signal('password');
    get passwordRegex(): RegExp {
        return /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Za-z])[A-Za-z0-9!@#$%^&*]{8,}$/;
    }

    passwordValidator() {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!this.passwordRegex.test(control.value)) {
                return { invalidPassword: true };
            }
            return null;
        };
    }

    onClose() {
        this.dialogRef.close();
    }

    showNotifier(message, type, button, duration) {
        this.notifier.openNotifier(message, type, button, duration);
    }

    toggleShowPassword() {
        if (this.passwordType() == 'password') {
            this.passwordType.set('text');
        } else {
            this.passwordType.set('password');
        }
    }

    onSubmit() {
        this.accountService
            .resetPassword({
                token: this.dialogData.token,
                password: this.formGroup.get('password')?.value ?? '',
            })
            .subscribe({
                next: (v) => {
                    this.dialogRef.close();
                    this.location.replaceState('/');
                    this.dialog.open(LoginModalComponent, {
                        scrollStrategy: this.overlay.scrollStrategies.noop(),
                    });
                    this.showNotifier('Your password has been changed. Please log in', 'snackbar-success', 'Close', 3000);
                },
                error: (v) => {
                    if (v.error && v.status == 400) {
                        this.errorMessage.set(v.error);
                    }
                },
            });
    }
}
